import styled from 'styled-components';
import 'animate.css';

import images from '../../../images';

const Container = styled.div`
  padding: 10px 20px;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

const Indicator = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;

  &.correct {
    background-image: url(${images.correct});
  }

  &.wrong {
    background-image: url(${images.wrong});
  }
`;

const GameStatusIndicator = ({ totalMaterials, doneMaterials }) => (
  <Container>
    {
      totalMaterials
        .map(({ mat_id, oidx }) => ((
          <Indicator
            className={
              doneMaterials[oidx] && doneMaterials[oidx].split('-')[1] === mat_id.toString() ? `${doneMaterials[oidx].split('-')[0]} animate__animated animate__bounce` : null
            }
          />
        )
        ))
    }
  </Container>
);

export default GameStatusIndicator;
